export default __webpack_public_path__ + "static/media/labeling.95536390.gif";